<div class="dpanel">
    <div class="dpanel-header bg-warning c-white">
        <div class="row">
            <div class="col-11 pt2">
                <span><i class="fas fa-info-circle c-white"></i></span> &nbsp;&nbsp;|&nbsp;&nbsp; {{data.title}}
            </div>
            <div class="col-1 text-right" *ngIf="!size.small">
                <button mat-icon-button color="secondary" (click)="close()" class="mat-ibtn-sm">
                    <i class="fas fa-times c-white fs14"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="dpanel-content">
        <div *ngIf="data.name === 'p1'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please ensure Family Name, Date of Birth and TFN matches with Tax Office record.
                        </li>
                        <li>
                            Please ensure Mobile no and Email is correct so that we can contact you for your Tax refund
                        </li>
                        <li>
                            You are authorizing us to add you as client in Tax Agent Portal. We will check your ATO
                            Records and check if you are entitled to Tax refund for prior years also
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'p2'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>Please enter current home address accurately.</li>
                        <li>Tax Office will send you letters at Postal address.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'p3'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please enter current home address accurately.
                        </li>
                        <li>
                            Tax Office will send you letters at Postal address
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'p4'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Required to find out your residency status and tax rates applicable
                        </li>
                        <li>
                            If unsure, then fill your status and write note to accountant in end.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i1'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Occupation – Select nearest occupation based on job daily duties/ job title
                        </li>
                        <li>
                            PAYG or Group Certificate- Annual summary given by employer showing year (at top), company
                            Name & ABN (in bottom), total income & tax deducted (in centre)

                        </li>
                        <li>
                            Last Payslip – Please enter Year to date (YTD) figures of Salary, Tax withheld
                        </li>
                        <li>
                            We can find your PAYG from ATO Portal (Fill all other information)
                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/1-Salary-or-wages-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i2'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Check your Bank Statement for Interest earned and Tax deducted (if any)
                        </li>
                        <li>
                            Bank will deduct Tax Only if you do NOT provide them your Tax File no
                        </li>
                        <li>
                            Ensure Interest Statement belongs to this financial year only
                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required

                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/10-Gross-interest-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i3'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Check figures from Dividend Statement provided by Company where you have invested
                        </li>
                        <li>
                            Ensure Dividend Statement belongs to this financial year
                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                    <li>
                        <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/11-Dividends-2018/" target="_blank">More Info - ATO Link</a>
                    </li>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i4'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Family Tax Benefit, rental assistance are tax free payments and are not shown in tax return
                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required


                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/5-Australian-Government-allowances-and-payments-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i5'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Family Tax Benefit, rental assistance are tax free payments and are not shown in tax return
                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required


                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/6-Australian-Government-pensions-and-allowances-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i6'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Payments can come from Life Insurance, Superannuation funds, RSA , ATO for other approved funds
                        </li>
                        <li>
                            Payment can be for death or Non-Death benefit

                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required



                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Income-questions-1-12/8-Australian-superannuation-lump-sum-payments-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i7'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Complete Only if you own a Rental Property and you earned rent/ property was available for rent
                            In last financial year

                        </li>
                        <li>
                            You only need to show your %share of Income and expenses (Joint owned properties)

                        </li>
                        <li>
                            Please attach these source documents-: Bank Interest statement, Council rates, Real estate
                            Financial year summary, Quantity Surveyor report (if Depreciation claimed), Land tax notice (if
                            Land tax paid), Repair bills (if total bills exceed $1000)

                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'i8'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Complete Only if have all related documents to prove these figures since ATO may ask
                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required
                        </li>
                    </ul>
                    <li>
                        <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Supplementary-tax-return/Income-questions-13-24/24-Other-income-2018/" target="_blank">More Info - ATO Link</a>
                    </li>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd1'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            You can NOT claim if you are driving Company car and company is paying all car expenses
                        </li>
                        <li>
                            You can NOT claim if you are travelling from Home to Work and Back
                        </li>
                        <li>

                            <strong>Log Book Method: </strong>you must have Log book in last financial year and all Tax Invoices for related expenses

                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D1-Work-related-car-expenses-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd2'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            You can only claim if You have paid (not your company)

                        </li>
                        <li>
                            You can NOT claim your personal / family travel expenses
                        </li>

                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required
                        </li>
                    </ul>
                    <li>
                        <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D2-Work-related-travel-expenses-2018/" target="_blank">More Info - ATO Link</a>
                    </li>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd3'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            You can NOT claim if it is daily wear clothes (without logo)
                        </li>
                        <li>
                            You must have written evidence if total claim on work related expenses are more than $300

                        </li>
                        <li>
                            If unsure, please write a note to accountant in END for review
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D3-Work-related-clothing,-laundry-and-dry-cleaning-expenses-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd4'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            HECS/HELP Fees paid is NOT deductible
                        </li>
                        <li>
                            You can NOT claim if expenses are borne by Company or reimbursed by Company

                        </li>
                        <li>
                            You can claim only if related to current job and improves your current job skill
                        </li>
                        <li>
                            You must have written evidence if total claim on work related expenses are more than $300
                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            &nbsp;<a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D4-Work-related-self-education-expenses-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                        <li>
                            There is a direct connection between the self-education and the taxpayer's current work activities
                        </li>
                    </ul>

                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd5'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            You can NOT claim if expenses are borne by Company or reimbursed by Company
                        </li>
                        <li>
                            You can claim only if related to current job and improves your current job skill

                        </li>
                        <li>
                            You must have written evidence if total claim on work related expenses are more than $300
                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D5-Other-work-related-expenses-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd6'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please check that Church receipt is tax deductible since Only FEW churches are DGR entity
                        </li>
                        <li>
                            Annual receipts from DGR usually show if it is tax deductible or not
                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required
                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D9-Gifts-or-donations-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'd7'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                        <li>
                            <a href="https://www.ato.gov.au/Individuals/Tax-return/2018/Tax-return/Deduction-questions-D1-D10/D10-Cost-of-managing-tax-affairs-2018/" target="_blank">More Info - ATO Link</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o1'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Spouse correct details are required for M1 exemption, Medicare surcharge etc.. Please provide
                            approx income of spouse if you do not have accurate income figure

                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o2'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please check Annual Statement of Hospital Cover is only attached

                        </li>
                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o3'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please check your recent HECS/HELP statement
                        </li>
                        <li>
                            Any debts may reduce your Tax refund
                        </li>
                        <li>
                            Centrelink/ Child Support agency may take part of your refund for any past/current debt
                        </li>
                        <li>
                            In case of debts, please ring Centrelink/ Child Support agency and make payment plan
                        </li>
                        <li>
                            If unsure, please write a note to accountant in end for review
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o4'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>SelectEnter seniors and pensioners (includes self funded retirees) offset code</li>
                        <li>
                            <strong>A</strong> &nbsp;&nbsp;&nbsp; At any time during the year the taxpayer was: single or widowed, or separated

                        </li>
                        <li>
                            <strong>B</strong> &nbsp;&nbsp;&nbsp; The taxpayer and their spouse-married or de facto-had to live apart due to illness or either of them were in a nursing home at any time during the year and they are both eligible for this tax offset

                        </li>
                        <li>
                            <strong>C</strong> &nbsp;&nbsp;&nbsp; The taxpayer and their spouse-married or de facto-had to live apart due to illness or either of them were in a nursing home at any time during the year but the taxpayer's partner is ineligible to claim this tax offset

                        </li>
                        <li>
                            <strong>D</strong> &nbsp;&nbsp;&nbsp; The taxpayer and their spouse-married or de facto-were living together and they are both eligible for this tax offset

                        </li>
                        <li>
                            <strong>E</strong> &nbsp;&nbsp;&nbsp; The taxpayer and their spouse-married or de facto-were living together but the taxpayer's partner is ineligible to claim this tax offset

                        </li>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o5'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>You have Free Medical facility with Defence forces Or</li>
                        <li>you are Temporary visa and Not Eligible for Medicare Card. You must have received Medicare Levy exemption certificate</li>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o6'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o7'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'o8'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'f1'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'f2'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Tax Office Mandatory requirement to Insert Bank details (No cheques by ATO)
                        </li>


                        <li>
                            You must provide your own Bank details.
                        </li>
                        <li>If you provide anyone else Bank details, it is your sole responsibility to recover</li>
                        <li>In case of incorrect bank details, you may lose the refund</li>
                        <li>Overseas Bank transfer takes longer time to receive</li>
                        <li>Your bank details are 100% safe and secure</li>

                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'f3'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>
                        <li>
                            Please upload photo ID proof. This is mandatory.
                        </li>

                        <li>
                            If unsure, please write a note to accountant in end for review
                            Accountant will review information and will contact you if required

                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'f4'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div *ngIf="data.name === 'fee'">
            <div class="row">
                <div class="col-md-12 info">
                    <ul>

                        <li>
                            If unsure, then write a note to accountant in END for review.
                            Accountant will review information and will contact you if required

                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
    <div class="dpanel-footer text-center">
        <button class="btn btn-warning btn-xs" (click)="close()"> <i class="fas fa-times fs14"></i> Close</button>
    </div>
</div>